import { StateScheme } from 'app/providers/StoreProvider/config/StateScheme'

export const getChartReleases = (state: StateScheme) => {
    return state.statistics.chartReleases
}
